import React from "react";
import Header from "../Header/Header";
import "./Hero.css";
import hero_image from "../../assets/hero_image.png";
import hero_image_back from "../../assets/hero_image_back.png";
import Heart from "../../assets/heart.png";
import Calories from "../../assets/calories.png";
import { motion } from "framer-motion";
import NumberCounter from "number-counter";
const mobile = window.innerWidth <= 768 ? true : false;
const Hero = () => {
  const transistion = { type: "spring", duration: 3 };
  return (
    <div className="hero" id="home">
      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header></Header>

        <div className="best-ad-in-market">
          <motion.div
            initial={{ left: mobile ? "178px" : "222px" }}
            whileInView={{ left: "8px" }}
            transition={{ ...transistion, type: "tween" }}
          ></motion.div>
          <span>BEST FITNESS CLUB IN THE MARKET</span>
        </div>

        {/* Hero Heading */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Shape</span>
            <span> Your</span>
          </div>
          <div>
            <span> Ideal Body</span>
          </div>
          <div>
            <span>
              In here we will help you to shape and build your ideal body and
              live up your life to fullest
            </span>
          </div>
        </div>
        {/* Figures */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter
                end={140}
                start={100}
                delay="4"
                prefix="+"
              ></NumberCounter>
            </span>
            <span>expret coaches</span>
          </div>
          <div>
            <span> <NumberCounter
                end={140}
                start={100}
                delay="4"
                prefix="+"
              ></NumberCounter></span>
            <span>members joined</span>
          </div>
          <div>
            <span> <NumberCounter
                end={140}
                start={100}
                delay="4"
                suffix="+"
              ></NumberCounter></span>
            <span>Fitness Program</span>
          </div>
        </div>
        <div className="hero-buttons">
          <button className="btn">Get Started</button>
          <button className="btn">Learn more</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Join Now</button>
        <motion.div
          initial={{ right: "-1rem" }}
          whileInView={{ right: "4rem" }}
          transition={{ transistion }}
          className="heart-rate"
        >
          <img src={Heart} alt="" />
          <span>Heart Rate</span>
          <span>116 bpm</span>
        </motion.div>
        {/* hero images */}
        <img src={hero_image} alt="" className="hero-image" />
        <motion.img
          initial={{ right: "11rem" }}
          whileInView={{ right: "20rem" }}
          transition={{ transistion }}
          src={hero_image_back}
          alt=""
          className="hero-image-back"
        />
        {/* Calories */}
        <motion.div
          initial={{ right: "37rem" }}
          whileInView={{ right: "28rem" }}
          transition={{ transistion }}
          className="calories"
        >
          <img src={Calories} alt="" />
          <div>
            <span>PERSONALIZE</span>
            <span>TRAINER</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
